import React from 'react';
// import { store } from 'src/store'

// just need for icon image to load https://stackoverflow.com/questions/60174040/marker-icon-isnt-showing-in-leaflet
import { Icon } from 'leaflet'
import L from "leaflet";

// import markerIconPng from "leaflet/dist/images/marker-icon.png"

import "leaflet/dist/leaflet.css";
import 'src/App.css';
import "src/styles.css";

import VectorGrid from "src/components/Dashboard/Map/VectorGrid";
import { risk_meta } from 'src/constants'
import { interpolateRainbow, interpolateRdYlGn } from 'd3-scale-chromatic';
import { color } from "d3-color";

// https://github.com/PaulLeCam/react-leaflet/issues/982
// import { CRS, LatLngBoundsExpression } from 'leaflet';

import { MapContainer, TileLayer, GeoJSON, Marker, useMapEvents, Popup } from 'react-leaflet';

import { countries } from "src/geojson"

import Map_legend_2 from "src/components/Dashboard/Map/Map_legend_2"

import { useAppSelector, useAppDispatch } from 'src/hooks';
import {
  overlayAsync,
  addPoint,
  loadAsset,
} from 'src/reducers/basicReducer';

import { config } from 'src/constants'

// require("src/services/fetch")
import { CreateInterceptors } from "src/services/fetch_retry";
const interceptors = CreateInterceptors.getInstance();
interceptors.registerInterceptors();

// export from here: https://colorbrewer2.org/#type=qualitative&scheme=Set1&n=8
const palette = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf'];

// https://stackoverflow.com/questions/54503275/react-leaflet-get-current-latlng-onclick
// https://stackoverflow.com/questions/34181804/anonymous-function-vs-const-function-javascript
// const LocationFinderDummy = () => {
function LocationFinderDummy() {
  const dispatch = useAppDispatch();

  useMapEvents({
    click(e) {
      console.log(e.latlng);
      //dispatch(overlayAsync(e.latlng));
      //dispatch(addPoint(e.latlng));
      dispatch(loadAsset(e.latlng));
    },
    // zoomstart seems like a better time than zoomend to refresh JWT for vectorgrid
    zoomstart: () => {
      console.log("zoomed!");
    },
    dragstart: () => {
      console.log("dragged!");
    },
  });
  return null;
};

// https://stackoverflow.com/questions/60312370/why-do-you-need-div-in-the-render-function-for-reactjs-components
function Earth_map() {
  const [map, setMap] = React.useState(null);

  // const [fields, setFields] = React.useState(null);
  // // const [color = "black"] = React.useState();
  // // const colors = ["green", "blue", "yellow", "orange", "grey"];

  // React.useEffect(() => {
  //   fetch(
  //     //config.url.FEATURE_URL + "collections/public.hex_2/items.json?limit=1000"
  //     config.url.API_URL + "api/feature_server/?x_min=0&y_min=0&x_max=10&y_max=10"
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       const fields = data;
  //       setFields(fields);
  //     })
  //     .catch((error) => console.log(error));
  // }, []);

  ////////////////////

  const newfeatures = countries.features;
  let betterfeatures = newfeatures.slice(0, 135);
  const newcountries: any = { type: countries.type, features: betterfeatures };

  const points = useAppSelector((state: any) => state.basic.pointData.coords);
  const site_name = useAppSelector((state: any) => state.basic.pointData.site_name);
  const ids = useAppSelector((state: any) => state.basic.pointData.ids);

  var legend;

  // TODO - can we make this so it only updates legend when variable changes?
  var map_legend_component = useAppSelector((state: any) => {
    if (state.basic.map.variable === "") {
      return null;
    }

    console.log("legend change needed");

    legend = new L.Control({ position: "topright" });

    var variable = state.basic.map.variable as string;

    return (
      // <div className="App">
      <Map_legend_2 var_name={variable} legend={legend} />
      // </div>
    );
  });

  var state_basic_map = useAppSelector((state: any) => {
    return { variable: state.basic.map.variable, scenario: state.basic.map.scenario, year: state.basic.map.year };
  });

  var opacity = useAppSelector((state: any) => { return state.basic.map.opacity });

  var vector_grid_component;
  if (state_basic_map.variable === "" || state_basic_map.scenario === "" || state_basic_map.year === "") {
    vector_grid_component = null;
  } else {
    var rast_name_current: string = state_basic_map.variable + "_" + state_basic_map.scenario + "_" + state_basic_map.year;
    console.log("VG rast name: " + rast_name_current);
    // index dictionary with string:
    // https://stackoverflow.com/questions/57086672/element-implicitly-has-an-any-type-because-expression-of-type-string-cant-b
    var vectorTileOptions = {
      rast_name: rast_name_current,
      // attribution:
      //   '© something',
      noWrap: true,
      vectorTileLayerStyles: {
        // A function for styling features dynamically
        'dynamic_hex_layer': function (props: any) {
          // console.log(color(interpolateRainbow(12.0 / 255))?.formatHex());
          // console.log(props.heat_ssp245_2035);
          const value_scaled = (props.value - risk_meta[rast_name_current as keyof typeof risk_meta].rast_min) / (risk_meta[rast_name_current as keyof typeof risk_meta].rast_max - risk_meta[rast_name_current as keyof typeof risk_meta].rast_min);
          const col_raw = color(interpolateRdYlGn(1 - value_scaled));
          var col = "blue";
          if (col_raw) {
            col = col_raw.formatHex();
            // console.log(col);
          }
          return {
            fillColor: col,
            fill: true,
            color: "black",
            weight: 0.25,
            fillOpacity: opacity //state.basic.map.opacity // TODO - see if we can set this at a higher level so it takes effect immediately
            // UPDATE - I think the weird dark hexagons come from the smooth zoom transition:
            // https://stackoverflow.com/questions/40555466/speedup-leaflet-map-refresh-after-zoom-change
            // That is, the old hexagons remain in the same region for a while, which effectively boosts the 
            // opacity temporarily. Setting "zoomAnimation={false}" in MapContainer fixes this, although it's kind
            // of clunky. TODO - see if we can completely erase the old hex as soon as zoom is clicked!
            // possibly, see also https://stackoverflow.com/questions/38881442/delay-between-basemap-and-vector-layer-when-zooming
          }
        }
      }
    };

    // need to include opacity in key so the vector tile alpha updates! TODO - consider if there's a way to change alpha
    // w/o reloading current vector tiles. Pretty sure "dynamic" styling of loaded tiles is possible.
    // https://stackoverflow.com/questions/56061167/re-style-entire-leaflet-vector-map-on-event
    // http://leaflet.github.io/Leaflet.VectorGrid/vectorgrid-api-docs.html#updating-styles
    vector_grid_component = <VectorGrid key={vectorTileOptions["rast_name"] + opacity} {...vectorTileOptions} />;
  };

  // https://www.wrld3d.com/wrld.js/latest/docs/leaflet/L.LatLngBounds/ (SW, NE)
  const map_bounds = [
    [10 - 40, -160],
    [10 + 40, 160],
  ] as L.LatLngBoundsExpression;

  /////////////////////////////////////////////////////////////////

  return (
    <div className="App">
      { /* need zoomSnap for fractional zoom: https://leafletjs.com/examples/zoom-levels
      Note - if we set an initial zoom level (meters per pixel at equator), result can look very different depending on map size
      in pixels. So, setting initial bounds instead. We could even store current bounds and then use fitBounds() after window is
      resized to ensure map extent is preserved across resizing. TODO - consider if this is worth pursuing. Might need to use
      invalidateSize() function. Relevant links:
      https://stackoverflow.com/questions/50861984/how-do-you-call-fitbounds-when-using-leaflet-react
      https://stackoverflow.com/questions/23910594/leaflet-responsive-design-creating-different-zoom-levels-for-different-screen
      https://stackoverflow.com/questions/40155099/how-to-make-the-map-bounds-responsive-in-leaflet
      */}
      <MapContainer bounds={map_bounds} zoomSnap={0.1} scrollWheelZoom={false} zoomAnimation={false} id="mapid">

        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          noWrap={true}
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* Will only update if we set a unique key!!! https://github.com/mhasbie/react-leaflet-vectorgrid/issues/9 */}
        {vector_grid_component}

        <LocationFinderDummy />

        {/* We get a warning if unique keys are provided. Evidently, these keys should be "above" the "Marker" level (??),
        so we can use Fragment. Also, we can add "i" to map call to get "unique" keys.
        https://stackoverflow.com/questions/34576332/warning-each-child-in-an-array-or-iterator-should-have-a-unique-key-prop-che
        Evidently, this is very bad when arrays are dynamic https://stackoverflow.com/questions/28329382/understanding-unique-keys-for-array-children-in-react-js/43892905#43892905
        TODO - see if we can use a better approach. Cleanest is probably to just give each point a unique ID that we keep in the object store. Can use this package
        https://www.npmjs.com/package/uuid , but it might be overkill. */}

        {points && points.length > 0 &&
          points.map((marker: any, i: any) => (
            <React.Fragment key={i}>
              <Marker
                position={[
                  marker.lat,
                  marker.lng
                ]}
                // marker shape is MIT licensed: https://www.svgrepo.com/svg/394268/map-marker-alt
                icon={new Icon({
                  iconUrl: `data:image/svg+xml;base64,${btoa(`
                    <svg width="18" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="m8.075 23.52c-6.811-9.878-8.075-10.891-8.075-14.52 0-4.971 4.029-9 9-9s9 4.029 9 9c0 3.629-1.264 4.64-8.075 14.516-.206.294-.543.484-.925.484s-.719-.19-.922-.48l-.002-.004zm.925-10.77c2.07 0 3.749-1.679 3.749-3.75s-1.679-3.75-3.75-3.75-3.75 1.679-3.75 3.75c0 2.071 1.679 3.75 3.75 3.75z" 
                            fill="${palette[ids[i]]}"/>
                    </svg>
                  `)}`,
                  iconSize: [18, 24],
                  iconAnchor: [9, 24]
                })}
              >
                <Popup>
                  {site_name[i]}
                </Popup>
              </Marker>
            </React.Fragment>
          ))}

        {map_legend_component}

        {/* <Map_legend_2 /> */}
        {/* <Map_legend /> */}

      </MapContainer>
    </div >
  );
}

export default Earth_map;